import React, { Component } from "react";

import "component/animation/Loading/styles.css";

class InstantWinIcon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: props.width ? props.width : 25,
      height: props.width ? props.width : 25,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        color: nextProps.selected ? nextProps.selectedcolor : nextProps.color,
      });
    }

    if (
      nextProps.width !== this.props.width ||
      nextProps.height !== this.props.height
    )
      this.setState({
        width: nextProps.width,
        height: nextProps.height,
      });
  }

  render() {
    return (
      <div className={this.props.className}>
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={`${this.state.width}px`}
          height={`${this.state.height * 1}px`}
          viewBox="0 0 850 850"
          style={{
            enableBackground: "new 0 0 850 850",
          }}
        >
          <path
            d="M319.08,238.37,67.5,356.34V638.46L323.8,760.15,574,643V359.34l-254.88-121M90.56,375.05,312.71,480.48V731.19L90.56,625.76V375.05m238.59,89.49L109.76,360.37l209.48-98.09L538.71,366.37,329.15,464.54M550.83,630l-215,100.69V485.13l215-100.77V630m-166.75-5.29q-10.47,0-19.12,10a46.18,46.18,0,0,0-10.23,24.47q-1.65,14.35,4.56,24.46T376,693.78q10.47,0,19.13-10.1a45.61,45.61,0,0,0,10.23-24.46q1.57-14.21-4.57-24.47-6.21-10-16.68-10m65.71-99.51q-10.47,0-19.05,10.1a45.15,45.15,0,0,0-10.23,24.39q-1.72,14.35,4.49,24.46t16.76,10.1q10.47,0,19.05-10.1A44.86,44.86,0,0,0,471,559.71q1.65-14.21-4.49-24.39t-16.76-10.1m54.14-33.85q10.47,0,19.12-10.1a45.85,45.85,0,0,0,10.23-24.47q1.58-14.28-4.56-24.46-6.22-10-16.69-10t-19.12,10a46,46,0,0,0-10.23,24.46q-1.65,14.28,4.57,24.47t16.68,10.1m-156-143.15q-11.88-7-28.88-7t-29,7q-11.88,7-11.88,17t11.88,17q12,7,29,7t28.88-7q12-7,12-17t-12-17M288.23,642.33q-8.73-11.52-21.17-13.89T245.9,634.2q-8.75,8.06-8.74,21.94a41.06,41.06,0,0,0,8.74,25.41q8.73,11.37,21.16,13.81t21.17-5.68q8.65-8.13,8.74-21.94a41.59,41.59,0,0,0-8.74-25.41m-21.17-158q-12.42-2.44-21.16,5.76-8.75,8.06-8.74,21.94a41.06,41.06,0,0,0,8.74,25.41q8.73,11.37,21.16,13.81t21.17-5.68q8.65-8.13,8.74-21.94a41.59,41.59,0,0,0-8.74-25.41q-8.73-11.52-21.17-13.89M229.45,563.1a41.29,41.29,0,0,0-8.81-25.41Q212,526.17,199.55,523.8t-21.17,5.76q-8.74,8.06-8.74,21.94a41.06,41.06,0,0,0,8.74,25.41q8.73,11.37,21.17,13.81T220.64,585q8.73-8.13,8.81-21.94m-74.52,12.31q-8.75-11.45-21.17-13.89t-21.17,5.76q-8.66,8.06-8.66,21.94a41.35,41.35,0,0,0,8.66,25.41q8.73,11.45,21.17,13.81t21.17-5.68q8.65-8.13,8.81-21.94a41.92,41.92,0,0,0-8.81-25.41m-21.17-158q-12.43-2.35-21.17,5.76t-8.66,21.94a41.35,41.35,0,0,0,8.66,25.41q8.73,11.37,21.17,13.81t21.17-5.68q8.65-8.13,8.81-21.94a41.92,41.92,0,0,0-8.81-25.41q-8.75-11.52-21.17-13.89M430,171.92A49.29,49.29,0,0,0,458,180q14.4,0,23.85-6.79,8.88-6.31,8.89-15.62t-8.89-17.2q-9.45-8.22-23.85-10.5-15.81-2.45-27.93,3.55-13.07,6.47-13,18.23-.07,11.76,13,20.28M601.51,532.64a24.74,24.74,0,0,0,5.19-.55,37.07,37.07,0,0,0,19.75-10.58,37.59,37.59,0,0,0,10.39-19.65c.21-1.15.37-2.34.47-3.55a23,23,0,0,0-4.33-16q-6.53-8.84-18.57-8.84a31,31,0,0,0-12.9,2.77v56.42M553.43,321.46l54.29,24H751.81L636,551.34H601.51v19.73h46.27L782.5,331.72,647.7,89.85H356.38L279,225.9l28.72-6.55,54.69-93.83,61,135,31.47,9.95L380.7,115.58H636l112.3,205.88H553.43M652.81,410q8.67,6.63,20.46,4.57a32.89,32.89,0,0,0,19-10.73,33.46,33.46,0,0,0,9-19.57q1.26-11.44-5.35-19.49-7.17-9-19.2-8.84-13,0-23,10.1-10.23,10.18-10.23,23.83,0,12.87,9.28,20.13m23.77-157.44q-15.81-2.52-28,3.47-13.07,6.56-13,18.31-.08,11.76,13,20.2a49.33,49.33,0,0,0,28,8.13q14.4,0,23.84-6.78,8.82-6.4,8.82-15.63,0-9.47-8.82-17.28-9.43-8.21-23.84-10.42m-152-40.88q-.09,11.76,13,20.29a49.73,49.73,0,0,0,28,8q14.33,0,23.77-6.78,8.9-6.31,8.89-15.63t-8.89-17.2q-9.45-8.28-23.77-10.5-15.81-2.44-28,3.55Q524.47,199.94,524.55,211.69Z"
            fill="url('#categoryNormal')"
          />
        </svg>
        {this.props.label && <div className="label">{this.props.label}</div>}
      </div>
    );
  }
}

export default InstantWinIcon;
